import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // Import translation hook
import '../../style/AddDisabilityPage.css'; // Import the CSS file

const AddDisabilityPage = () => {
    const { id } = useParams(); // Get pet ID from URL
    const navigate = useNavigate(); // For redirection
    const { t } = useTranslation(); // Translation function
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000'; // Backend URL
    const [newDisability, setNewDisability] = useState({
        name: '',
        diagnosisDate: '',
        notes: '',
    });
    const [error, setError] = useState(null);

    const handleCreateDisability = async () => {
        try {
            const storedUser = JSON.parse(localStorage.getItem('user')); // Retrieve user data from localStorage
            const token = storedUser?.token;

            if (!token) {
                throw new Error(t('general.noAuthToken')); // Use translation for error
            }

            // Create the disability
            const disabilityResponse = await fetch(`${baseUrl}/api/pets/${id}/conditions`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`, // Include token in Authorization header
                },
                body: JSON.stringify({
                    name: newDisability.name,
                    type: 'disability', // Specify type as 'disability'
                    diagnosisDate: newDisability.diagnosisDate,
                    notes: newDisability.notes,
                }),
            });

            if (!disabilityResponse.ok) {
                throw new Error(t('disability.createFailed')); // Use translation for error
            }

            const addedDisability = await disabilityResponse.json(); // Expect the backend to return only the newly created disability
            console.log(addedDisability); // Debug log

            if (!addedDisability._id) {
                throw new Error(t('disability.missingDisabilityId')); // Use translation for error
            }

            navigate(`/pet/${id}/conditions/${addedDisability._id}`); // Redirect to the Condition Page
        } catch (error) {
            setError(error.message);
            console.error(error);
        }
    };

    return (
        <div className="add-disability-form bg-dafauna-background rounded-xl shadow-md p-8">
            <h3 className="text-dafauna-darkText text-2xl font-bold text-center mb-4">{t('disability.title')}</h3>
            {error && <p className="error-message text-red-500 text-center">{error}</p>}
            <div className="form-group">
                <label htmlFor="disabilityName" className="block text-dafauna-darkText font-medium mb-2">
                    {t('condition.disabilityName')}
                </label>
                <input
                    type="text"
                    id="disabilityName"
                    placeholder={t('condition.disabilityNamePlaceholder')}
                    value={newDisability.name}
                    onChange={(e) => setNewDisability({ ...newDisability, name: e.target.value })}
                    required
                    className="form-input border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-dafauna-primary"
                />
            </div>
            <div className="form-group">
                <label htmlFor="diagnosisDate" className="block text-dafauna-darkText font-medium mb-2">
                    {t('condition.diagnosisDate')}
                </label>
                <input
                    type="date"
                    id="diagnosisDate"
                    placeholder={t('condition.diagnosisDatePlaceholder')}
                    value={newDisability.diagnosisDate}
                    onChange={(e) => setNewDisability({ ...newDisability, diagnosisDate: e.target.value })}
                    required
                    className="form-input border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-dafauna-primary"
                />
            </div>
            <div className="form-group">
                <label htmlFor="notes" className="block text-dafauna-darkText font-medium mb-2">
                    {t('condition.notes')}
                </label>
                <textarea
                    id="notes"
                    placeholder={t('condition.notesPlaceholder')}
                    value={newDisability.notes}
                    onChange={(e) => setNewDisability({ ...newDisability, notes: e.target.value })}
                    className="form-textarea border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-dafauna-primary"
                />
            </div>
            <button
                onClick={handleCreateDisability}
                className="create-disability-page-btn w-full bg-dafauna-primary text-white rounded-md px-4 py-2 hover:bg-dafauna-primaryLight disabled:bg-gray-300 disabled:cursor-not-allowed"
            >
                {t('disability.createButton')}
            </button>
        </div>
    );
};

export default AddDisabilityPage;